import { render } from "./SelectIdP-Callback.vue?vue&type=template&id=84f6d8a8&scoped=true"
import script from "./SelectIdP-Callback.vue?vue&type=script&lang=js"
export * from "./SelectIdP-Callback.vue?vue&type=script&lang=js"

import "./SelectIdP-Callback.vue?vue&type=style&index=0&id=84f6d8a8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-84f6d8a8"]])

export default __exports__